import React, { useState } from "react";
import { Col, Nav, NavItem, Row, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TeamMembers } from "../../containers/Team/TeamMembers";
import GroupsContainer from "../../containers/Protocols/Groups/GroupsContainer";
import Card from "../../components/Cards/Card";

export const TeamView = (props) => {
    const { t } = useTranslation();
    const [selectedSubTab, setSelectedSubTab] = useState("personal");

    const handleSubTabChange = (tab) => {
        setSelectedSubTab(tab);
    };

    return (
        <Card
            content={
                <Tab.Container id="team-subtabs-startup" activeKey={selectedSubTab} onSelect={handleSubTabChange}>
                    <Row className="clearfix">
                        <Col sm={12}>
                            <Nav bsStyle="tabs">
                                <NavItem eventKey="personal">
                                    {t("clinicalTrials.team.personal")}
                                </NavItem>
                                <NavItem eventKey="group">
                                    {t("clinicalTrials.team.group")}
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col sm={12}>
                            <Tab.Content animation mountOnEnter={true}>
                                <Tab.Pane eventKey="personal">
                                    <TeamMembers {...props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="group">
                                    <GroupsContainer />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }
        />
    );
}